module.exports = __webpack_public_path__ + "static/img/third2_2_1_active.07b565b2.jpg";